import { type ReactElement, useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { SessionExpiredScreen } from './SessionExpiredScreen';

export const SessionExpired = (): ReactElement => {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshSession, signOut } = useAuth();
  const returnTo = useMemo(
    () =>
      location.state && typeof location.state === 'object'
        ? (location.state as { from?: string }).from
        : '/',
    [location.state],
  );

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          window.clearInterval(timer);
          void navigate('/', { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => {
      window.clearInterval(timer);
    };
  }, [navigate]);

  const handleRetry = useCallback(async (): Promise<void> => {
    const refreshed = await refreshSession();
    if (refreshed) {
      void navigate(returnTo ?? '/', { replace: true });
      return;
    }
    signOut();
    void navigate('/', { replace: true });
  }, [navigate, refreshSession, returnTo, signOut]);

  return <SessionExpiredScreen countdown={countdown} onRetry={handleRetry} />;
};
